/**
 * created by zhangling on 2020/2/24
 */
import { EventEmitter } from 'events';

const emitter = new EventEmitter()
emitter.setMaxListeners(0)

export default emitter;
